import React, { useMemo } from 'react'
import {
    createManageCandidateStore,
    ManageCandidateStoreContext,
} from './manageCandidateStore'

export const ManageCandidateProvider: React.FC<{
    children: React.ReactNode
}> = ({ children }) => {
    // Create a new store instance when this provider mounts
    const store = useMemo(() => createManageCandidateStore(), [])
    return (
        <ManageCandidateStoreContext.Provider value={store}>
            {children}
        </ManageCandidateStoreContext.Provider>
    )
}
